import React from 'react';
import PropTypes from 'prop-types';
import CrudTab from 'react/containers/pages/CrudTab';
import RetriedLogsCrud from 'react/containers/pages/RetriedLogs/RetriedLogsCrud';

class RetriedLogs extends CrudTab {
  activeClassName = 'is-active';
  componentDidMount() {
    const {
      tab: {
        extra: { id }
      }
    } = this.props;

    try {
      new App.Routers.RetriedLogs(id);
    } catch (error) {
      console.log(`Error at instatiate App.Routers.RetriedLogs: ${error.message}`)
    }
  }

  renderCrud = () => {
    const {
      tab: {
        extra: { id }
      },
      updateTitle
    } = this.props;

    return (
      <>
        <RetriedLogsCrud
          id={id}
          nameSpace={`RetriedLogs_${id}`}
          entity={`RetriedLogs_${id}`}
          customOptions={{
            rowHeight: 32,
            sanitizer: null
          }}
          isGrid={true}
          updateTitle={updateTitle}
        />
      </>
    );
  }
}

RetriedLogs.propTypes = {
  onClose: PropTypes.func,
  active: PropTypes.bool
};

export default RetriedLogs;
